import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['linkedIds']

  declare readonly linkedIdsTarget: HTMLInputElement

  preserveLinkedIds (): void {
    const linkedEvidenceIdsField = document.getElementById('linked-evidence-ids') as HTMLInputElement | null
    if (linkedEvidenceIdsField?.value != null && linkedEvidenceIdsField.value !== '') {
      this.linkedIdsTarget.value = linkedEvidenceIdsField.value
    }
  }

  handleSubmit (): void {
    this.preserveLinkedIds()
  }
}
